import LazyVideo from "../components/LazyVideo";

export default function SnowInterview() {
  return (
    <div className="bg-gradient-to-b from-slate-100 to-royalBlue ">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-4 p-4 max-w-screen-xl mx-auto">
        {/* Horizontal Text Box - Move this BELOW the first horizontal image to appear on second row */}
        <div className="col-span-3 sm:col-span-2 lg:col-span-2 row-span-2 aspect-video bg-white rounded-2xl shadow-md p-6 flex items-center justify-center text-center lg:grid-cols-2">
          <div>
            <h1 className="text-royalBlue text-xl pt-2 font-semibold">
              🎤 Interview with SNOW: Behind the Legacy of “Informer”
            </h1>
            <p className="text-s text-gray-800">
              {" "}
              G.C.M. Production sat down with Darrin Kenneth O’Brien — better
              known as SNOW, the Canadian reggae artist behind the iconic hit
              “Informer”, for an exclusive, in-depth interview. With his
              signature charm and raw honesty, SNOW opened up about his journey
              through fame, reinvention, and staying grounded through decades in
              the music industry.
            </p>
          </div>
        </div>

        {/* Horizontal Video */}
        <div className="aspect-video col-span-3 bg-black rounded-2xl overflow-hidden shadow-md">
          <LazyVideo
            autoPlay
            muted
            loop
            controls
            playsInline
            className="w-full h-full object-cover"
          >
            <source
              src="../Imgs/SnowInterview/CLIP INTERVIEW SNOW.MP4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </LazyVideo>
        </div>

        {/* Horizontal Image */}
        <div className="col-span-1 sm:col-span-2 lg:col-span-2 row-span-1 bg-black rounded-2xl overflow-hidden shadow-md">
          <img
            src="../Imgs/SnowInterview/Snow behind the scenes.JPG"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  );
}
